//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { validationMessage } from 'vuelidate-messages';

const formMessages = {
  // required: () => 'Required',
  required: function () {
    return this.$i18n.t('error.required');
  },
  // minLength: ({ $params }) => `Must be at least ${$params.minLength.min} characters.`,
  minLength: function ({ $params }) {
    return this.$i18n.t('error.must_be_at_lease_{count}_characters', { count: $params.minLength.min });
  },
  maxLength: function ({ $params }) {
    return this.$i18n.t('error.must_be_less_than_{count}_characters', { count: $params.maxLength.max });
  },
  email: function () {
    return this.$i18n.t('error.invalid_email_address');
  },
  sameAsPassword: function () {
    return this.$i18n.t('error.passwords_do_not_match');
  },
  containAlpha: function () {
    return this.$i18n.t('error.must_contain_alphabetic');
  },
  containNumber: function () {
    return this.$i18n.t('error.must_contain_numeric');
  },
  invalidNumber: function () {
    return this.$i18n.t('error.invalid_number');
  },
  invalidUrl: function () {
    return this.$i18n.t('error.invalid_url');
  },
  // https://github.com/motionelements/frontend-monorepo/pull/8561/files
  apiValidationErrorMessage: function () {
    return this.invalidFeedback;
  },
};

export default {
  name: 'base-input-text',
  props: {
    id: String,
    label: String,
    value: {
      type: [String, Number],
      default: '',
    },
    v: {
      type: Object,
    },
    type: {
      type: String,
      default: 'text',
    },
    name: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
    },
    mask: {
      type: [String, Array],
      required: false,
      default: '',
    },
    showErrorMsg: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noInvert: {
      type: Boolean,
      default: false,
    },
    invalidFeedback: String,
  },
  data() {
    return {
      isAutoFilled: false,
    };
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        if (this.supportApiValidation) this.$store.commit('apiValidationErrors/clearErrors');
        this.$emit('input', value);
      },
    },
    isRequired() {
      return _.has(this.v, '$params.required');
    },
    supportApiValidation() {
      return _.has(this.v, 'apiValidationErrorMessage');
    },
  },
  watch: {
    isAutoFilled(val, oldVal) {
      console.log('========== WATCH isAutoFilled ', val, oldVal);
      if (val) {
        this.$refs.input.parentElement.classList.add('form-control-filled');
      }
    },
  },
  mounted() {
    if (this.label && this.autocomplete) {
      const interval = setInterval(() => {
        this.checkingAutoFill(interval);
      }, 500);
      setTimeout(() => {
        clearInterval(interval);
      }, 2000);
    }
  },
  beforeDestroy() {
    if (this.supportApiValidation) this.$store.commit('apiValidationErrors/clearErrors');
  },
  methods: {
    getValidationMessage: validationMessage(formMessages),
    checkingAutoFill(interval) {
      this.isAutoFilled = window.getComputedStyle(this.$refs.input).getPropertyValue('appearance') === 'menulist-button';
      console.log('checkingAutoFill', this.isAutoFilled);
      if (this.isAutoFilled) {
        clearInterval(interval);
      }
    },
  },
};
